enum CompanyHotelPriceRecommendationEngine {
	BRAINTRUST = 'BRAINTRUST',
	ROOMPULSE = 'ROOMPULSE'
}

export default CompanyHotelPriceRecommendationEngine